module.exports = __webpack_public_path__ + "img/travel.f3d2037b.png";